/**
 * Where a session should start. Used after login and after impersonation, so
 * both land on the area the account actually works in instead of a learner home
 * page that a manager, admin or employer has no use for.
 */
export const resolveLandingRoute = (roles: string[]): string => {
  if (roles.includes("EMPLOYER_ADMIN") || roles.includes("EMPLOYER_MANAGER")) {
    return "/employer/dashboard";
  }
  if (roles.includes("TENANT_ADMIN")) {
    return "/tenant-admin-dashboard";
  }
  if (roles.includes("TENANT_MANAGER")) {
    return "/tenant-manager-dashboard";
  }
  return "/home";
};

export const useLandingRoute = () => {
  const sessionStore = useSessionStore();
  return computed(() => resolveLandingRoute(sessionStore.userRoles));
};
